import React, { useEffect, useState } from "react";
import "./assets/scss/App.scss";
import logo from "./assets/images/ciputra/ciputra_logo.png";

function App() {
  const [data, setData] = useState(null);

  useEffect(() => {
    // Ganti URL dengan endpoint API Anda
    fetch("http://localhost:4000/api/v1/cek-status/+6281389771866")
      .then((response) => response.json())
      .then((data) => setData(data))
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  if (!data) {
    return <div>Loading...</div>;
  }

  const totalAntrian = data.total;
  const dilayani = data.isCalled;
  const sisa = totalAntrian - dilayani;
  const nama_dokter = data.data.nama_dokter;
  const nama_poli = data.data.nama_poli;
  const tanggal_periksa = data.data.tanggal_periksa;
  const nama_pasien = data.data.nama_pasien;
  const dob = data.data.tanggal_lahir;
  const no_rm = data.data.no_rm;

  const DonutChart = ({ total, done }) => {
    const radius = 45;
    const circumference = 2 * Math.PI * radius;
    const donePercentage = (done / total) * 100;
    const offset = circumference - (donePercentage / 100) * circumference;
  
    return (
      <svg className="w-full h-full" viewBox="0 0 100 100">
        <circle
          cx="50"
          cy="50"
          r="45"
          stroke="lightgray"
          strokeWidth="10"
          fill="none"
        />
        <circle
          cx="50"
          cy="50"
          r="45"
          stroke="orange"
          strokeWidth="10"
          fill="none"
          strokeDasharray={`${circumference} ${circumference}`}
          strokeDashoffset={offset}
          transform="rotate(-90 50 50)"
        />
      </svg>
    );
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-200">
      <div className="bg-white p-6 rounded-lg shadow-lg">
        <div className="text-center mb-4">
          <img src={logo} alt="Logo" className="mx-auto mb-12" />
          <div className="bg-orange-200 p-4 rounded-lg">
            <p>{nama_dokter}</p>
            <p>{nama_poli} </p>
            <p>{tanggal_periksa} </p>
            <hr className="my-2" />
            <p>{nama_pasien} </p>
            <p>{dob} </p>
            <p>{no_rm} </p>
          </div>
        </div>
        <div className="relative w-64 h-64 mx-auto">
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-center">
              <p className="text-4xl font-semibold">Antrian</p>
              <p className="text-4xl font-bold">{totalAntrian}</p>
              <p>Dilayani: {dilayani}</p>
              <p>Sisa: {sisa}</p>
            </div>
          </div>
          <DonutChart total={totalAntrian} done={dilayani} />
        </div>
        <button className="mt-4 bg-green-500 text-white py-2 px-4 rounded-lg" onClick={() => window.location.reload()}>
          Refresh
        </button>
      </div>
    </div>
  );
}

export default App;
